import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "main"
}
const _hoisted_2 = { class: "main-left" }
const _hoisted_3 = { class: "main-right" }
const _hoisted_4 = { class: "content" }

import { useI18n } from 'vue-i18n';
import { computed, watch } from 'vue';
import Header from '@/components/Application/AppHeader.vue';
import SideBar from '@/components/Application/AppSideBar.vue';
import Footer from '@/components/Application/AppFooter.vue';
import LoginView from '@/views/sys/login/LoginView.vue';
import LoadingSPinner from '@/components/Application/AppLoadingSpinner.vue';
import store from '@/store/index';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t } = useI18n();
const loginFlag = computed(() => {
	return store.getters['app/myAccessToken'] == '';
});
const isLoading = computed(() => {
	return store.getters['app/appLoading'] == '';
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loginFlag.value)
      ? (_openBlock(), _createBlock(LoginView, {
          key: 0,
          class: "login"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(SideBar)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Header),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_RouterView)
            ]),
            _createVNode(Footer)
          ])
        ])),
    (!isLoading.value)
      ? (_openBlock(), _createBlock(LoadingSPinner, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})